import React, {  useEffect, useState } from 'react';
import optService from '../services/OtpApiService';
import helper from '../factory/Helper';
import useCountDown from 'react-countdown-hook';
import config from '../appconfig/config.json';
import Loading from '../components/Loading';
import CusToast from '../components/CusToast';
let count3TimeToExist = 0;
let count3TimeExpired = 0;

const OTPbar = (props) => {

    const {id,userMobileNo,currentTime, history,otpTimer } = props;

    let timer = otpTimer;

    const initialTime = 120 * 1000; // initial time in milliseconds, defaults to 60000
    const interval = 1000; // interval to change remaining time amount, defaults to 1000
    const [timeLeft, { start, pause, resume, reset }] = useCountDown( initialTime, interval );

    const [otpAuthToken,setOTPAuthToken] = useState();
    const [OTPValue, setOTPValue] = useState("");
    const [OtpconfirmDisabled, setOtpconfirmDisabled] = useState(false);
    const [isOtpGeneratedSuccess,setIsOtpGeneratedSuccess] = useState(false);

    const [isError,setIsError] = useState(false);
    const [errMsg, setErrMsg] = useState('');

    const [isOtpLoading,setIsOtpLoading] = useState(false);
    const [showOTPResendRequestErr, setShowOTPResendRequestErr] = useState(false);

    //Default Error Msg
    const otpApiFailed = 'Oops!\nSomething went wrong. Please try again.';
    const otpExpired = 'The OTP entered has expired/is invalid. Please re-enter the 6-digit OTP.';
    const validOtpInput = 'Please enter valid numeric 6-digit OTP';
    const firstOtpTryFailed = 'The OTP entered has expired/ is invalid. Please re-enter the 6-digit OTP. 2 tries left.';
    const secondOtpTryFailed = 'The OTP entered has expired/is invalid. Please re-enter the 6-digit OTP. 1 try left.';
       
    useEffect(() => {
        console.log('@OTPbar useEffect');
        const newTime = 120 * 1000;
        start(newTime);
        getOTPSecurityToken();
    }, []);

   

    const handleResendOTP = (e) => {
        if(timeLeft === 0) {
            setShowOTPResendRequestErr(false);
            const newTime = 120 * 1000;
            start(newTime);
            generateOTP(otpAuthToken,userMobileNo);
        }
        else {
            setShowOTPResendRequestErr(true);
        }
    }


    const handleRequestOTP = (e) => {
        e.preventDefault();
       // request btn click, generate OTP
       generateOTP(otpAuthToken,userMobileNo);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
    
        if(OTPValue.length === 6) {

            if(config.EnableOTPAPI) {
                if(timeLeft === 0) {  //check generated OTP expired time
                    count3TimeExpired = count3TimeExpired+1;
                    setOTPValue('');
                    showErrMsg(otpExpired);
                    return;
                }    
                count3TimeToExist = count3TimeToExist + 1;
            }
        
            verifyOTPDetails();
        }
       
    }

    const getOTPSecurityToken =()=>{
    
        setIsOtpLoading(true);
        optService.OTPSecurity().then(res => {
            setIsOtpLoading(false);
            let resData = res.data;
            if(resData){
                setOTPAuthToken(resData.token);
            }           
        })
        .catch(err => {
            console.log('@getOTPSecurityToken: ',err);
            setIsOtpLoading(false);
        });
    }
    const isNumber = async (evt) => { // allow number
        evt = evt ? evt : window.event;
        var charCode = evt.which ? evt.which : evt.keyCode;
    
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
          await setOTPValue("");
          await setOtpconfirmDisabled(false);
          return false;
        } else {
          await setOtpconfirmDisabled(true);
          return true;
        }
    };

        
    const handleOTPInput =  async (e) => {  // get and set OTP number 
        const re = /^[0-9\b]+$/;
        if (e.target.value === "" || re.test(e.target.value)) {
          await setOTPValue(e.target.value);
        }
 
        if (e.target.value.length === 6) {
          await setOtpconfirmDisabled(true);
        } else {
          await setOtpconfirmDisabled(false);
        }
    };

    const getTodayDate = () => {
        const  months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        let today = new Date();
        let dd =  String(today.getDate()).padStart(2, '0');
        let mm =  months[today.getMonth()];
        let yyyy = today.getFullYear();
        today = dd + ' ' + mm + ' '+yyyy;
        return today;
    }

    const otpDisplayMsg = () => {
        let msg = '';
        if(showOTPResendRequestErr) {
            msg = 'You have already submitted an OTP request earlier. To avoid multiple requests, please wait a few minutes for your OTP to be sent to you before making another request.' 
        }
        else {
            msg = 'OTP has been sent to +65'+ helper.mask(userMobileNo,4)+' ('+getTodayDate()+' '+currentTime+'). If you did not receive,'
        }
        return msg;
    }

    const disableSubmitOTPBtn = () => {
        let disableBtn = false;
        if(!OTPValue){
            disableBtn = true;
        }
        else if(OTPValue.length !== 6) {
            disableBtn = true;
        }

        return disableBtn;
    }

    const showErrMsg = (msg) => {
        setIsError(true);
        setErrMsgTimeout();
        if(msg !== null) {
            setErrMsg(msg);
        }
        else {
            setErrMsg(config.error.GetApiFailed);
        }
    }

    const setErrMsgTimeout= () => {
        timer = setTimeout(() => {
            setIsError(false);
            if(count3TimeToExist === 3 || count3TimeExpired === 3) {
               // console.log('Invalid OTP Page')
                gotoInvalidOTP();
                return;
            }
        }, config.error.msgTimeout);
    }
    
    const generateOTP = (token, mno) => {
        if(config.EnableOTPAPI === false){ //API Call Disable
            setIsOtpGeneratedSuccess(true);
            return;
        }
        //API Call Enable
        setIsOtpLoading(true);
        let mobileNum = mno; //response.MobileNonsm
        let accessId = "5911";
        let countryCode = "00065";
        let legalID = "T0499906H";
        optService.OTPGeneration(mobileNum, accessId, countryCode, legalID,token)
            .then(async (res) => {
                setIsOtpLoading(false);
                const data = res.data;
                if (!data.didError) {
                    let res = data.model.msg;
                    let resMsgBdy = res.msgBody;
                    let resMsgHdr = res.msgHdr;
                    if (resMsgHdr.statusDesc === "Success") {
                        start();
                        setIsOtpGeneratedSuccess(true);
                    }
                    else {
                        showErrMsg(otpApiFailed)
                        setIsOtpGeneratedSuccess(false);
                    }
                }
            })
            .catch((err) => {
                console.log(err);
                setIsOtpLoading(false);
                showErrMsg(otpApiFailed)
                setIsOtpGeneratedSuccess(false);
            });
    
    }

    const verifyOTPDetails = async () => {

        if (OTPValue) {
            if(!config.EnableOTPAPI) {
                OTPSubmitSuccess();
                return;
            }
            setIsOtpLoading(true);
          // let req = setAllOTPResponces;
          let mobileNum = userMobileNo; //response.MobileNonsm
          let accessId = "5911";
          let countryCode = "00065";
          let legalID = "T0499906H";
          let OTP = OTPValue;
  
          optService
            .OTPVerification(mobileNum, OTP, accessId, countryCode, legalID,otpAuthToken)
            .then(async (res) => {
                setIsOtpLoading(false);
              const data = res.data;
              if (!data.didError) {
                let res = data.model.msg;
                let resMsgBdy = res.msgBody;
                let resMsgHdr = res.msgHdr;
             
                if (resMsgHdr.statusCode === "0") {
                  OTPSubmitSuccess();
                } else {
                    showOTPErrMsg();
                }
              }
            })
            .catch((err) => {
                console.log('@verifyOTPDetails: ',err);
                setIsOtpLoading(false);
                showErrMsg(otpApiFailed);
                count3TimeToExist = 0;
            });
    
        } else {
          await setOtpconfirmDisabled(true);
          showErrMsg(validOtpInput);
        }
      };

    const gotoInvalidOTP = () => {
        //route to error screen
        history.push(config.route.InvalidOTP);
    }

    const showOTPErrMsg = () => {
        if (count3TimeToExist <= 3) {
            setOTPValue('');
            if(count3TimeToExist === 1) {
                showErrMsg(firstOtpTryFailed);
            }
            else if(count3TimeToExist === 2) {
                showErrMsg(secondOtpTryFailed)
            }
            else if(count3TimeToExist === 3) {
                gotoInvalidOTP();
            }
        } else {
            gotoInvalidOTP();
            return;
        }
    }

     
    const OTPSubmitSuccess = () => {
        //do the api call 
       props.handleOTPSubmitSuccess();
    }

    
    const toHHMMSS = (val) => {
        var sec_num = parseInt(val / 1000, 10); 
        var hours = Math.floor(sec_num / 3600);
        var minutes = Math.floor((sec_num - hours * 3600) / 60);
        var seconds = sec_num - hours * 3600 - minutes * 60;
  
        if (hours < 10) {
            hours = "0" + hours;
        }
        if (minutes < 10) {
            minutes = "0" + minutes;
        }
        if (seconds < 10) {
            seconds = "0" + seconds;
        }
        return minutes + ":" + seconds;
  }

    return(
        <div id={id}>
            {!isOtpGeneratedSuccess?
            <div className="row around-xs elementVisible yellow-bottom-bar">
                <div className="col-xs-12 col-sm-2 col-md-2 col-lg-2">
                    <div className="box"></div>
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                    <div className="box">
                        <div className="otp-info-txt">SMS OTP: Get the 6-digit OTP via SMS to<br/>verify your account</div>
                    </div>
                </div>
                <div className="col-xs-12 col-sm-2 col-md-2 col-lg-2">
                    <div className="box">
                        <div className="otp-input">
                            {/* <input className="k-textbox" type="password"  
                                placeholder="SMS OTP" name="" id="OTPValue" disabled={true} /> */}
                        </div>
                    </div>
                </div>
                <div className="col-xs-12 col-sm-2 col-md-2 col-lg-2">
                    <div className="box">
                        <div className="otp-btn">
                            <button className="k-button btn btn-success" onClick={handleRequestOTP}>{'REQUEST'}</button>
                        </div>
                    </div>
                </div>
                <div className="col-xs-12 col-sm-2 col-md-2 col-lg-2">
                    <div className="box"></div>
                </div>
            </div>:
            <div className="row around-xs elementVisible yellow-bottom-bar">
                <div className="col-xs-12 col-sm-2 col-md-2 col-lg-2">
                    {showOTPResendRequestErr? 
                    <div className="otp-sent-txt">
                      <span className="k-icon k-i-warning" style={{paddingLeft:'10px', fontSize:'24px'}} />&nbsp; 
                      OTP request unsuccessful
                    </div>
                    :
                    <div className="otp-sent-txt">
                      <span className="k-icon k-i-check-outline" style={{paddingLeft:'10px', fontSize:'24px'}} />&nbsp; 
                      OTP has been sent 
                    </div>
                    }
                </div>
                <div className="col-xs-12 col-sm-5 col-md-5 col-lg-5">
                    <div className="box row">
                    <div className="otp-timer-txt">
                    {showOTPResendRequestErr?
                        <div style={{padding:'5px'}}>
                            {otpDisplayMsg()}
                            <br/>
                            <span style={{fontWeight:'bold'}} onClick={handleResendOTP}> 
                              {timeLeft === 0?
                                "Resend OTP"
                                :
                                "Resend in "+toHHMMSS(timeLeft)
                              }
                            </span>
                        </div>
                        :
                        <div style={{padding:'5px'}}>
                            {otpDisplayMsg()}
                            <span style={{fontWeight:'bold'}} onClick={handleResendOTP}>&nbsp;click here</span>
                        </div>
                    }
                    </div>
                    </div>
                </div>
                <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3">
                    <div className="box row">
                        <span className="k-icon k-i-clock otp-click-icon"  />
                        <div className="otp-timer-input">
                            <input className="k-textbox" type="password" pattern="[0-9]+" maxLength="6" minLength="6" value={OTPValue}
                                onKeyPress={isNumber} placeholder="SMS OTP" name="" id="OTPValue" disabled={!isOtpGeneratedSuccess} onChange={handleOTPInput} />
                        </div>
                    </div>
                </div>
                <div className="col-xs-12 col-sm-2 col-md-2 col-lg-2">
                    <div className="box row">
                        <div className="otp-btn">
                            <button className="k-button btn btn-success" disabled={disableSubmitOTPBtn()} onClick={handleSubmit}>{'Next'}<span className="k-icon k-i-arrow-right" /></button>
                        </div>
                    </div>
                </div>
         
            </div>}
            {isOtpLoading && (
                <Loading /> 
            )}
            <CusToast className="popUpBox" trigger={isError} setTrigger={setIsError} label={errMsg} timer={timer}  /> 
        </div>
    )
}

export default OTPbar;